import type { RemoteSubmissionStatus } from '@/classes/SubmissionStatuses/types'
import { purchaseApiAxiosInstance } from '@/services/purchaseApiAxiosInstance'

type SubmissionStatusFetchResponse = {
	data: Record<string, RemoteSubmissionStatus>
}

export const useSubmissionStatusService = () => {
	const getStatusForPlanIds = async (
		planIds: Array<string>
	): Promise<Record<string, RemoteSubmissionStatus>> => {
		try {
			const response =
				await purchaseApiAxiosInstance.get<SubmissionStatusFetchResponse>(
					`v2/submission/fetch-status`,
					{
						params: { planIds },
						withCredentials: true,
					}
				)
			return response.data.data
		} catch (e) {
			console.error(
				e,
				'Something went wrong while fetching for submission status'
			)
			throw e
		}
	}

	const getSubmissionErrors = async (
		salesforceContactAfpId: string
	): Promise<Record<string, RemoteSubmissionStatus>> => {
		try {
			const response =
				await purchaseApiAxiosInstance.get<SubmissionStatusFetchResponse>(
					'v2/submission/errors',
					{
						params: { salesforceContactAfpId },
						withCredentials: true,
					}
				)

			return response.data.data
		} catch (e) {
			console.error(e, 'Something went wrong while fetching submission errors')
			throw e
		}
	}

	return {
		getStatusForPlanIds,
		getSubmissionErrors,
	}
}
